'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Segments = function (_Component) {
  _inherits(Segments, _Component);

  function Segments() {
    _classCallCheck(this, Segments);

    return _possibleConstructorReturn(this, (Segments.__proto__ || Object.getPrototypeOf(Segments)).apply(this, arguments));
  }

  _createClass(Segments, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['className']);

      var cx = (0, _classnames2.default)('segments', className);

      return _react2.default.createElement(_Box2.default, _extends({
        ts: true,
        className: cx
      }, rest));
    }
  }]);

  return Segments;
}(_react.Component);

Segments.displayName = 'Segments';

exports.default = Segments;
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNlZ21lbnRzLmpzIl0sIm5hbWVzIjpbIlNlZ21lbnRzIiwicHJvcHMiLCJjbGFzc05hbWUiLCJyZXN0IiwiY3giLCJkaXNwbGF5TmFtZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7Ozs7Ozs7Ozs7SUFFTUEsUTs7Ozs7Ozs7Ozs7NkJBQ0s7QUFBQSxtQkFJSCxLQUFLQyxLQUpGO0FBQUEsVUFFTEMsU0FGSyxVQUVMQSxTQUZLO0FBQUEsVUFHRkMsSUFIRTs7QUFLUCxVQUFJQyxLQUFLLDBCQUNQLFVBRE8sRUFFUEYsU0FGTyxDQUFUOztBQUtBLGFBQ0U7QUFDRSxnQkFERjtBQUVFLG1CQUFXRTtBQUZiLFNBR01ELElBSE4sRUFERjtBQU9EOzs7Ozs7QUFHSEgsU0FBU0ssV0FBVCxHQUF1QixVQUF2Qjs7a0JBRWVMLFEiLCJmaWxlIjoiU2VnbWVudHMuanMiLCJzb3VyY2VSb290IjoiRDpcXFByb2plY3RzXFxyZWFjdC10b2Nhc1xcc3JjIn0=



//////////////////
// WEBPACK FOOTER
// ../lib/Segments.js
// module id = 574
// module chunks = 0